function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import * as EditorContext from "../EditorContext";
import * as OverlayContext from "../OverlayContext";
import Player from "../../Player";
import Overlay from "../Overlay";

var Video = function (_React$Component) {
  _inherits(Video, _React$Component);

  function Video() {
    var _temp, _this, _ret;

    _classCallCheck(this, Video);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleScaleChanged = function (scale) {
      _this.props.EditorContext.video.setScale(scale);
    }, _this.handleVideoPropsReceived = function (props) {
      _this.props.EditorContext.video.setVideoProps(props);
    }, _this.handleTimeChanged = function (time) {
      _this.props.OverlayContext.setCurrentTime(time);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Video.prototype.render = function render() {
    var EditorContext = this.props.EditorContext;
    var _EditorContext$state = EditorContext.state,
        video = _EditorContext$state.video,
        logo = _EditorContext$state.logo,
        isPreviewEnabled = _EditorContext$state.isPreviewEnabled,
        frame = _EditorContext$state.frame;

    var _EditorContext$frames = EditorContext.frames.getFrames(),
        _EditorContext$frames2 = _EditorContext$frames.frames,
        frames = _EditorContext$frames2 === undefined ? [] : _EditorContext$frames2,
        selectedFrameId = _EditorContext$frames.selectedFrame;

    var selectedFrame = frames.find(function (frame) {
      return frame.id === selectedFrameId;
    });
    return video.src ? React.createElement(Player, {
      playerRef: function playerRef(player) {
        return EditorContext.setVideoPlayer(player);
      },
      autoPlay: true,
      autoHideControlBar: false,
      disableControlBarControls: true,
      videoSrc: video.src,
      logo: logo,
      startTime: video.currentTime,
      onScaleChange: this.handleScaleChanged,
      onVideoPropsReceived: this.handleVideoPropsReceived,
      onTimeChanged: this.handleTimeChanged
    }, React.createElement(Overlay, {
      selectedFrame: isPreviewEnabled ? selectedFrame : null
    })) : null;
  };

  return Video;
}(React.Component);

Video.propTypes = process.env.NODE_ENV !== "production" ? {
  EditorContext: PropTypes.object.isRequired,
  OverlayContext: PropTypes.object.isRequired
} : {};
export default EditorContext.consumeContext(OverlayContext.consumeContext(Video));